export class ComponentIndex {
  public componentName: string;
  public componentIndex: number;

  constructor(componentIndex: number, componentName: string) {
    this.componentIndex = componentIndex;
    this.componentName = componentName;
  }
}
